export const TOGGLE_MODAL_RESEND = 'TOGGLE_MODAL_RESEND';

export function toggleModalResend(onlySendCodeView = false) {
  return {
    type: TOGGLE_MODAL_RESEND,
    onlySendCodeView,
  };
}
